import store from "@/store"

export default function superadmin({ next, router }) {
    if(!store || !store.state.auth.isLogged || !['superadmin', 'supermanager'].includes(store.state.auth.user.role)) {
        router.push('/admin/login')
        return
    }
    return next()
}
